<template>
  <div>
    <EmptyList title="Em construção" class="py-12" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'

import PATHS from '@/router/paths'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'
import EmptyList from '@/components/EmptyList.vue'

const route = useRoute()
const headerStore = useHeaderStore()

onMounted(() => {
  const pageTitle = (route.meta.pageTitle as string) || 'Políticas'
  headerStore.setTitle(pageTitle, '', { label: 'Políticas', route: PATHS.POLICIES_HOME })
})
</script>
